import type { Brand } from '@/modules/filter/models/filter.model'

export const useTheme = () => {
  const apply = (brand?: Brand): void => {
    const root = document.querySelector<HTMLElement>(':root')

    if (!root) return

    const colors = {
      '--color-brand': brand ? brand.primaryColor : '#53ab47',
      '--color-brand-contrast': brand ? brand.primaryTextColor : '#ffffff',
      '--color-surface': brand ? brand.secondaryTextColor : '#ffffff',
      '--color-surface-inverse': brand ? brand.secondaryColor : '#242426',
      '--color-accent-light': brand ? brand.footerTextColor : '#ffffff',
      '--color-accent-dark': brand ? brand.footerColor : '#242426',
    }

    Object.entries(colors).forEach(([prop, value]) => {
      if (value) {
        root.style.setProperty(prop, value)
      }
    })
  }

  return { apply }
}
